import { z } from "zod";
import { toFormikValidationSchema } from "zod-formik-adapter";

const forgotPasswordFormSchema = toFormikValidationSchema(
    z
        .object({
            newPassword: z
                .string("ForgotPassword.ResetYourPassword.Error_NewPassword_Required")
                .min(6, "ForgotPassword.ResetYourPassword.Error_Password_6_Characters"),
            confirmNewPassword: z
                .string("ForgotPassword.ResetYourPassword.Error_ConfirmNewPassword_Required")
                .nullable(),
        })
        .refine((data) => data.confirmNewPassword === null || data.confirmNewPassword === data.newPassword, {
            message: "ForgotPassword.ResetYourPassword.Error_ConfirmNewPassword_NotMatch",
            path: ["confirmNewPassword"],
        }),
);

export default forgotPasswordFormSchema;
